import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const getUnpaidOrders = async (asOfDate, { page, pageSize, status } = {}) => {
  try {
    const response = await axios.post(`${BACKEND_URL}/api/company/unpaid-orders`, {
      asOfDate: asOfDate,
      page,
      pageSize,
      status
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const generatePaymentLink = async (customerId) => {
  try {
    const response = await axios.post(`${BACKEND_URL}/api/company/payment/generate-link`, {
      customerId: customerId
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export { getUnpaidOrders, generatePaymentLink };
